<script setup lang="ts">
  import { QuotedPlanVm } from '~/models/quoting/QuotedPlan'
  import type { PlanBannerConfig } from '~/composables/PlanBanners'
  import QuoteCardFooter from '~/components/quote/card/QuoteCardFooter.vue'

  const props = defineProps<{
    quote: QuotedPlanVm
    id?: string
    banner?: Partial<PlanBannerConfig & { text: string }> | null | undefined
    stacked?: Boolean
  }>()

  const { getId } = Id.use(props.id ?? props.quote.medicareId)
  const { devModeEnabled, openInConnecture, isHeatEnabled } = DevModeHelpers.use()
</script>

<template>
  <QuoteCardMonthlyBase :id="getId()" :quote="quote" :banner="banner" class="monthly-card isolate">
    <template #header>
      <QuoteCardHeaderMonthly
        :quote="quote"
        :banner="banner"
        :id="getId('header')"
        :stacked="stacked"
      />
    </template>
    <template #default>
      <div>
        <QuoteCardSectionMonthlyScoreCosts
          :stacked="stacked"
          :quote="quote"
          :id="getId('monthly-score-costs')"
        />
      </div>
      <QuoteCardSectionBenefitButtons
        :quote="quote"
        :id="getId('benefitButtons')"
        hide-header
        simple
      />

      <QuoteCardSectionActionsButtons :quote="quote" />

      <template v-if="devModeEnabled && isHeatEnabled(quote)">
        <aside class="-mb-4 mt-5 flex items-center justify-center gap-1.5">
          <HpIcon name="login" class="w-4 text-primary" />
          <HpAnchor class="text-sm font-bold" @click.prevent="openInConnecture(quote.externalId)">
            Open app in Connecture
          </HpAnchor>
        </aside>
      </template>
    </template>

    <template #footer>
      <QuoteCardFooter :quote="quote" class="!border-none" />
    </template>
  </QuoteCardMonthlyBase>
</template>

<style scoped></style>
